/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import * as React from 'react';
import { Input, Icon, Checkbox } from 'cn-next';
import './style/index.scss';
import { useControlValue } from './hooks';
import { debounce, isDef, isFunction, isString } from './util';
export default function ListFilter(props) {
    const { list, labelKey, valueKey, className, style, searchStyle, searchTransform, column, } = props;
    const [search, setSearch] = React.useState('');
    const onChangeSearch = debounce((val) => {
        setSearch(val);
    }, 500, false);
    const allValue = React.useMemo(() => getAllValue(list, valueKey), [list]);
    const filterList = React.useMemo(() => getFilterList(list, isFunction(searchTransform) ? searchTransform(search) : search, labelKey), [list, search, labelKey]);
    // console.log(allValue, 'allValue');
    const [value, setValue] = useControlValue(props, {
        defaultValuePropName: 'defaultValue',
        valuePropName: 'value',
        changePropName: 'onChange',
        defaultValue: [],
    });
    // console.log(value, 'value');
    const filterValue = React.useMemo(() => {
        return (filterList?.filter((item) => {
            return value.includes(item.id);
        }) || []);
    }, [filterList, value]);
    const [openKeys, setOpenKeys] = useControlValue(props, {
        defaultValuePropName: 'defaultOpenKeys',
        valuePropName: 'openKeys',
        changePropName: 'onChangeOpenKeys',
        defaultValue: [],
    });
    const valueMap = React.useMemo(() => {
        return Array.isArray(value)
            ? value.reduce((ret, next) => ({
                ...ret,
                [next]: true,
            }), {})
            : {};
    }, [value]);
    const openKeysMap = React.useMemo(() => {
        return Array.isArray(openKeys)
            ? openKeys.reduce((ret, next) => ({
                ...ret,
                [next]: true,
            }), {})
            : {};
    }, [openKeys]);
    const onChange = (changeValue, checked) => {
        const ret = Array.isArray(value) ? [...value] : [];
        if (checked && !valueMap[changeValue]) {
            ret.push(changeValue);
            setValue(ret);
        }
        else if (!checked && valueMap[changeValue]) {
            const valueSet = new Set(ret);
            valueSet.delete(changeValue);
            setValue(Array.from(valueSet));
        }
    };
    const onChangeOpenKeys = (changeOpenKey, isOpen) => {
        const ret = Array.isArray(openKeys) ? [...openKeys] : [];
        if (isOpen && !openKeysMap[changeOpenKey]) {
            ret.push(changeOpenKey);
            setOpenKeys(ret);
        }
        else if (!isOpen && openKeysMap[changeOpenKey]) {
            const valueSet = new Set(ret);
            valueSet.delete(changeOpenKey);
            setOpenKeys(Array.from(valueSet));
        }
    };
    const onCheckAll = (checked) => {
        setValue(checked ? [...allValue] : []);
    };
    const onCheckAllFilterValue = (checked) => {
        const filterValueList = filterList?.map((item) => item.id);
        if (checked) {
            setValue([...value, ...filterValueList]);
        }
        else {
            setValue(allValue.filter((item) => filterList.includes(item)));
        }
    };
    // @ts-ignore
    function renderList(list, level = 1) {
        return Array.isArray(list)
            ? list.map((item = {
                children: [],
            }, index = 1) => (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `cn-list-filter-item ${valueMap[item?.[valueKey ?? 'value']]
                        ? 'cn-list-filter-selected'
                        : ''}`, key: item?.[valueKey ?? 'value'] },
                    item?.children?.length > 0 ? (React.createElement(CaretRightIcon, { className: openKeysMap[item?.[valueKey ?? 'value']] &&
                            'cn-list-filter-opened', onClick: () => {
                            onChangeOpenKeys(item?.[valueKey ?? 'value'], !openKeysMap[item?.[valueKey ?? 'value']]);
                        } })) : null,
                    React.createElement(Checkbox, { checked: valueMap[item?.[valueKey ?? 'value']] ?? false, onChange: (checked) => {
                            onChange(item?.[valueKey ?? 'value'], checked);
                        }, className: 'cn-list-filter-checkbox' }),
                    column?.render instanceof Function
                        ? column.render(item?.[column.code ?? column.key ?? labelKey ?? ''], item, level === 1 ? index : -1)
                        : isUndefOrNullString(item[labelKey ?? 'label'])
                            ? '空'
                            : item[labelKey ?? 'label']),
                openKeysMap[item?.[valueKey ?? 'value']] && (React.createElement("div", { style: { marginLeft: level * 16 }, className: 'cn-list-filter-list' }, renderList(item?.children, level + 1))))))
            : null;
    }
    return (React.createElement("div", { style: style, className: `cn-list-filter${className ? ` ${className ?? ''}` : ''}` },
        React.createElement(Input, { innerBefore: React.createElement(Icon, { type: 'search', style: { margin: 4 } }), placeholder: 'search', className: 'cn-list-filter-search', onChange: onChangeSearch, style: searchStyle }),
        React.createElement("div", { className: 'cn-list-filter-list cn-list-filter-wrapper' },
            !search ? (React.createElement("div", { className: `cn-list-filter-item ${allValue.length === value?.length ? 'cn-list-filter-selected' : ''}` },
                React.createElement(Checkbox, { checked: allValue.length === value?.length, className: 'cn-list-filter-checkbox', onChange: onCheckAll }),
                "\u5168\u9009(",
                value?.length ?? 0,
                "/",
                allValue?.length ?? 0,
                ")")) : filterList?.length ? (React.createElement("div", { className: `cn-list-filter-item ${allValue.length === filterList?.length
                    ? 'cn-list-filter-selected'
                    : ''}` },
                React.createElement(Checkbox, { checked: filterValue.length === filterList?.length, className: 'cn-list-filter-checkbox', onChange: onCheckAllFilterValue }),
                "\u5168\u9009\u641C\u7D22\u9879\u76EE(",
                filterValue?.length ?? 0,
                "/",
                filterList?.length ?? 0,
                ")")) : null,
            renderList(filterList, 1))));
}
function dfs(list, handlerCallback) {
    Array.isArray(list) &&
        list.forEach((item) => {
            handlerCallback instanceof Function && handlerCallback(item);
            if (item?.children?.length > 0) {
                dfs(item?.children, handlerCallback);
            }
        });
}
// 是否为叶子结点
function isLeafNode(item) {
    return !(item?.children?.length > 0);
}
function dfsHouxu(list, handlerCallback, level = 1) {
    Array.isArray(list) &&
        list.forEach((item) => {
            if (item?.children?.length > 0) {
                dfsHouxu(item?.children, handlerCallback, level + 1);
            }
            handlerCallback instanceof Function && handlerCallback(item, level);
        });
}
function getAllValue(list, valueKey) {
    const allValue = [];
    dfs(list, (item) => {
        if ((valueKey ?? 'value') in item) {
            allValue.push(item?.[valueKey ?? 'value']);
        }
    });
    return allValue;
}
function getNewNode(labelKey) {
    return {
        [labelKey ?? 'label']: '',
        value: '',
        children: [],
    };
}
function getFilterList(list, search, labelKey = 'label') {
    if (search === '') {
        return list;
    }
    let nowNodes = null;
    let nowNodeLevel = -1;
    let nowTree = null;
    let nowTreeLevel = -1;
    dfsHouxu(list, (item, level) => {
        if (nowNodeLevel === -1) {
            // 初始化
            nowNodeLevel = level;
            nowNodes = getNewNode(labelKey);
        }
        if (level < nowNodeLevel) {
            // 增加了一层，就做一层统计
            if (nowNodes && nowNodes?.children?.length > 0) {
                // 当前有节点, 则新建
                const newTempNode = {
                    ...item,
                    children: nowNodes?.children,
                };
                nowNodes = {
                    ...getNewNode(labelKey),
                    children: [newTempNode],
                };
            }
            if (level === nowTreeLevel && nowTree && nowNodes) {
                // 重新返回
                nowTree.children = nowTree.children.concat(nowNodes.children);
                nowNodes = nowTree;
            }
        }
        else if (level > nowNodeLevel) {
            // 开始深入下去
            // 记录当前start
            nowTreeLevel = nowNodeLevel;
            nowTree = nowNodes;
            // 记录当前end
            nowNodeLevel = level;
            nowNodes = getNewNode(labelKey);
            if (item &&
                isString(item[labelKey ?? 'label']) &&
                item[labelKey ?? 'label'].includes(search)) {
                nowNodes?.children?.push?.(item);
            }
        }
        else if (level === nowNodeLevel) {
            // 平层，开始compare
            // @ts-ignore
            if (item &&
                isString(item[labelKey ?? 'label']) &&
                item[labelKey ?? 'label'].includes(search)) {
                nowNodes?.children?.push?.(item);
            }
        }
        // 同步层次
        nowNodeLevel = level;
    });
    // @ts-ignore
    return nowNodes && nowNodes.children ? nowNodes.children : list;
}
function CaretRightIcon(props) {
    return (React.createElement("svg", { focusable: 'false', preserveAspectRatio: 'xMidYMid meet', fill: 'currentColor', width: '16', height: '16', viewBox: '0 0 32 32', ...props },
        React.createElement("path", { d: 'M12 8L22 16 12 24z' })));
}
function isUndefOrNullString(val) {
    return !isDef(val) || (isString(val) && val.replace(/\s/g, '') === '');
}
